<div class="page-content">

    <div class="content__holder">
      <h2>Welcome to our Home Fire Safety Visit (HFSV) Partner site</h2>

      <div class="panel">
        <p>
          This site is no longer available due to transitioning to the live HFSV Application, which will launch on 12th February 2025.
        </p>

        <p>
          Please note <b>registration of organisations</b> will not be progressed during this time.
        </p>

        <p>
          A link to the application will be available via <b><a href="https://www.firescotland.gov.uk">Fire Scotland</a></b> website.
        </p>


      </div>

    </div>
</div>
